import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'

const SectionAccordion = ({
  title,
  defaultExpanded = true,
  children
}: { title: string; defaultExpanded?: boolean; children: React.ReactNode }) => (
  <Accordion defaultExpanded={defaultExpanded} className='order-show-section'>
    <AccordionSummary expandIcon={<i className='fa fa-chevron-down' />}>
      <Typography variant='h6'>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
)

export default SectionAccordion
